import React, { lazy } from "react";
import { Route } from "react-router-dom";
import AdminProfileView from "../../pages/admin-dashboard/admin-profile/admin-profile-view";
import AdminNotifications from "../../pages/admin-dashboard/admin-notifications";
import ProtectedRoute from "../PrivateRoute";

// Lazy load admin pages
const AdminDashboard = lazy(() => import("../../pages/dashboard/Dashboard"));
const AdminOverview = lazy(() => import("../../pages/admin-dashboard/admin-overview"));
const AdminUsers = lazy(() => import("../../pages/admin-dashboard/admin-users"));
const AdminUserDetail = lazy(() => import("../../pages/admin-dashboard/admin-user-detail"));
const lists = () => import("../../pages/admin-dashboard/admin-lists");
const AdminMasjids = lazy(() => lists().then((m) => ({ default: m.AdminMasjids })));
const AdminWebsites = lazy(() => lists().then((m) => ({ default: m.AdminWebsites })));
const AdminDevices = lazy(() => lists().then((m) => ({ default: m.AdminDevices })));
const AdminSubscriptions = lazy(() => lists().then((m) => ({ default: m.AdminSubscriptions })));
const tickets = () => import("../../pages/admin-dashboard/admin-tickets");
const AdminTickets = lazy(() => tickets().then((m) => ({ default: m.AdminTickets })));
const AdminTicketDetail = lazy(() => tickets().then((m) => ({ default: m.AdminTicketDetail })));

const adminRoutes = [
  <Route
    path="/admin-dashboard/*"
    element={
      <ProtectedRoute requiredPermission={[0]}>
        <AdminDashboard />
      </ProtectedRoute>
    }
    key="admin-dashboard"
  >
    <Route index element={<AdminOverview />} />
    <Route path="users" element={<AdminUsers />} />
    <Route path="users/:id" element={<AdminUserDetail />} />
    <Route path="masjids" element={<AdminMasjids />} />
    <Route path="websites" element={<AdminWebsites />} />
    <Route path="devices" element={<AdminDevices />} />
    <Route path="subscriptions" element={<AdminSubscriptions />} />
    <Route path="support" element={<AdminTickets type="support" key="support" />} />
    <Route path="feature-requests" element={<AdminTickets type="feature" key="feature" />} />
    <Route path="tickets/:id" element={<AdminTicketDetail />} />

    {/* admin-profile */}
    <Route path="admin-profile" element={<AdminProfileView />} />
    <Route path="admin-notifications" element={<AdminNotifications />} />
  </Route>
];

export default adminRoutes;
